import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
// import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
// import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_ResponsivePIXIApp } from "../SlotGameType1_ResponsivePIXIApp";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import { IPanelFactory } from "../panel/IPanelFactory";
import { PanelParams } from "../panel/IPanelFactory";
import { Panel , ButtonColors} from "../panel/panel";
// namespace SlotGames {


    export class EternalFortuneStack_ResponsivePIXIApp extends SlotGameType1_ResponsivePIXIApp {

        
        protected override helpFactory: IHelpFactory = new EternalFortuneStackHelpFactory();
        protected override panelColor: ButtonColors ={
			backgroundButtonColor: "linear-gradientrgb(64, 1, 1),rgb(115, 2, 2), rgb(166, 3, 3),rgb(115, 2, 2),rgb(64, 1, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			linearColor:"linear-gradient(to left , transparent, LightPink,transparent ) 0 10 100%",
		}
        //LED COLOR
		protected override ColorLed:string="173,83,255\n";
        
        constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string = "EternalFortuneStack") {
            super(multigameParams, initData, gameName);

            this.spinnableReelsParams.topBorderWidth = 8;
            this.spinnableReelsParams.bottomBorderWidth = 8;
        }

        // protected PrepareFonts(resourceManager: ResourceManager): void {

        //     resourceManager.Add(new FontResource(this.basepath + "resources/CuteJellyfish.ttf", this.resid.ScopedResourceName(["BigSymbolFreeGames-font"])));

        // }
        //SEND COLOR FOR RSA 
        protected override color: RewardColor =
            {
                color: "#F1F0C9",
                coloroutherStroke: "black",
                colorinnerStroke: "#9F8DF4",
            }
    }

    //Panel Colorized
    class EternalFortuneStackPanelFactory implements IPanelFactory {
        public CreateNewPanel(params: PanelParams): Panel {
            return new EternalFortuneStackPanel(params);
        }
    }

    class EternalFortuneStackPanel extends Panel {
        // protected override ButtonBackground(): ButtonColors {
        //     let color: ButtonColors = {
        //         backgroundButtonColor: "linear-gradient(rgb(28, 3, 38),rgb(115, 6, 77), rgb(217, 108, 159),rgb(115, 6, 77),rgb(28, 3, 38)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        //         linearColor: "linear-gradient(to left , transparent, LightPink,transparent ) 0 10 100%",
        //     };

        //     return color;
        // }

    }
    class EternalFortuneStackHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new EternalFortuneStackHelp(params);
        }
    }

    class EternalFortuneStackHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(1, 38, 3),rgb(1, 64, 5), rgb(3, 166, 44),rgb(1, 64, 5),rgb(1, 38, 3)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }


// }
